module.exports = __webpack_public_path__ + "img/leader-photo.65731e82.png";